export default "__VITE_ASSET__BPn9SrLE__"